var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 23.274534,10.559248 21.66844,8.6979595 C 21.361393,8.3445592 21.113393,7.6848786 21.113393,7.2136782 V 5.2110765 c 0,-1.248681 -1.027428,-2.2735419 -2.279238,-2.2735419 h -2.007617 c -0.460572,0 -1.133714,-0.2473801 -1.488,-0.5536603 L 13.472633,0.78179286 c -0.814857,-0.69502058 -2.149331,-0.69502058 -2.975998,0 L 8.6425165,2.3956542 C 8.2882309,2.6901545 7.6150883,2.9375346 7.154517,2.9375346 H 5.1114702 c -1.2518091,0 -2.2792373,1.0248609 -2.2792373,2.2735419 v 2.0143817 c 0,0.4594204 -0.2479998,1.119101 -0.5432379,1.4725013 L 0.6947099,10.571028 c -0.68495213,0.812821 -0.68495213,2.132182 0,2.945003 l 1.5942851,1.873021 c 0.2952381,0.353401 0.5432379,1.013082 0.5432379,1.472501 v 2.014382 c 0,1.248682 1.0274282,2.273542 2.2792373,2.273542 H 7.154517 c 0.4605713,0 1.1337139,0.247381 1.4879995,0.55366 l 1.8659275,1.602082 c 0.814858,0.69502 2.149332,0.69502 2.975999,0 l 1.865904,-1.602082 c 0.354286,-0.306279 1.015619,-0.55366 1.488,-0.55366 h 2.007618 c 1.251809,0 2.279237,-1.02486 2.279237,-2.273542 v -2.002602 c 0,-0.45942 0.248,-1.13088 0.555048,-1.484281 l 1.606094,-1.861241 c 0.684952,-0.812821 0.684952,-2.155743 -0.01181,-2.968563 z M 16.897395,9.8171075 11.193397,15.506852 c -0.165334,0.16492 -0.389715,0.25916 -0.625905,0.25916 -0.236191,0 -0.460571,-0.09424 -0.6259047,-0.25916 L 7.0836599,12.65609 c -0.342476,-0.341621 -0.342476,-0.907061 0,-1.248682 0.3424761,-0.341619 0.9093331,-0.341619 1.2518091,0 l 2.232023,2.226423 5.078093,-5.0654517 c 0.342477,-0.3416202 0.909334,-0.3416202 1.25181,0 0.342475,0.3416204 0.342475,0.9070608 0,1.2487282 z",
    fill: "#65a30d",
    id: "path2",
    style: {
      strokeWidth: 1.17947
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.bc55facb2c6b374a95f371d06e8cf75a.svg";
export { ForwardRef as ReactComponent };